export default {

  DIALOG_HIDE: 'dialogHide',

  DIALOG_SHOW: 'dialogShow',

  LOGGER_ADD_MSG: 'loggerAddMessage',

  POPUP_ADD_MESSAGE: 'popupAddMessage',

  POPUP_CLEANUP_MESSAGES: 'popupCleanupMessages',

  PROGRESS_INDICATOR_TOGGLE: 'progressIndicatorToggle',

  FEEDBACK_CREATE_NEW: 'feedbackCreateNew',

  FEEDBACK_UPDATE_PROPERTY: 'feedbackUpdateProperty',
};
